import { useState, useEffect } from "react";

const useScrollUpVisibility = () => {
  const [isScrollUpVisible, setIsScrollUpVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      // ScrollUp typically becomes visible after scrolling down a certain amount
      const threshold = 300;
      setIsScrollUpVisible(scrollPosition > threshold);
    };

    // Check initial state
    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return isScrollUpVisible;
};

export default useScrollUpVisibility;
